import { SmartTable } from '../../../../../../components/smart-table/smart-table.model';
import { accountFromDto } from '../../../account.dto';

export class Controller {

    /** @ngInject */
    constructor($q, $state, $uibModal, AccountsResource, Alert, GroupsResource) {
        this.$q = $q;
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.GroupsResource = GroupsResource;
    }

    $onInit() {
        this.username = '';
        this.searchText = '';
        this.lastSearchText = '';
        this.form = 'newForm';
        this.st = new SmartTable();
    }

    focusNewForm() {
        this.form = 'newForm';
        this.searchText = '';
        this.lastSearchText = '';
        this.foundAccounts = null;
    }

    focusExistingForm() {
        this.form = 'existingForm';
        this.username = '';
    }

    save() {
        const rejectAlreadyExistingAccount = (account) => {
            if (account.justCreated) {
                return this.$q.resolve(account);
            } else {
                this.$uibModal
                    .open({component: 'companyUserDirectoriesManageUserAddAccountAccountAlreadyExists'}).result
                    .then(() => this.$state.go('company.user-directories.manage-account', {accountId: account.id}));
                return this.$q.reject();
            }
        };

        this.isSaving = true;
        (this.form === 'newForm'
                ? this.GroupsResource
                    .addNewUserToGroup(this.companyId, this.group.id, this.username)
                    .then(accountFromDto)
                    .then(rejectAlreadyExistingAccount)
                : this.AccountsResource
                    .copyUsersToGroup(this.companyId, [this.group.id], this.st.selectedIds)
        )
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.user-directories.manage-group.accounts.add.added'))
            .finally(() => this.isSaving = false)
    }

    saveDisabled() {
        return this.isSaving || this.isSearching ||
            this.form === 'newForm' && !this.username ||
            this.form === 'existingForm' && !this.st.selectedItems.length;
    }

    search() {
        this.isSearching = true;
        this.foundAccounts = null;
        this.AccountsResource
            .getAccountsByUsername(this.companyId, this.group.id, this.searchText)
            .then((accounts) => {
                this.foundAccounts = accounts;
                this.lastSearchText = this.searchText;
            })
            .finally(() => this.isSearching = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/add/add-account-to-group.controller.js